import { render } from "./SlideToGive.vue?vue&type=template&id=eca0b698"
import script from "./SlideToGive.vue?vue&type=script&lang=js"
export * from "./SlideToGive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__